export default __webpack_public_path__ + "static/media/supplier_box_image.7efc8889.jpg";